import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Panel } from '@atlaskit/navigation-system/layout/panel';
import { Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { type ConversationAssistantConfig } from '@atlassian/conversation-assistant';

import { StagingAreaChatContainer } from './chat';
import { PreviewContainer } from './preview';

type StagingAreaContainerProps = {
	spaceKey: string;
	config: ConversationAssistantConfig;
	conversationId: string;
};

const styles = cssMap({
	wrapperStyles: {
		backgroundColor: token('elevation.surface.sunken'),
		flex: 1,
		width: '100%',
	},
	fullWidth: {
		width: '100%',
		flex: 1,
	},
});

export const StagingAreaContainer = ({ config }: StagingAreaContainerProps) => {
	return (
		<Flex xcss={styles.wrapperStyles}>
			<Flex xcss={styles.fullWidth}>
				<Flex xcss={styles.fullWidth}>
					<PreviewContainer />
				</Flex>
				<Panel defaultWidth={450}>
					<StagingAreaChatContainer config={config} />
				</Panel>
			</Flex>
		</Flex>
	);
};
